export const LOCALES = ['fr', 'en', 'de', 'fi']
